import React from 'react';
import '../../../ui/BrandFrame/BrandFrame.css';
import './PhotoGrid.css';
import './PhotoGridPresentation.css';
import wrappedIcon from '../../../../assets/icons/wrapped.jpeg';

interface PhotoGridProps {
    onShowCard: () => void;
}

// Hover and focus affordances are CSS (:hover, :focus-visible), so the TV remote sees
// the same lift a mouse does.
const PhotoGrid: React.FC<PhotoGridProps> = ({ onShowCard }) => (
    <div className="photo-grid-container">
        <div className="photo-grid">
            <div className="panel panel-1 hover-zoom wrapped-btn-only">
                <button
                    className="story-launch-button spotify-wrapped-btn"
                    onClick={onShowCard}
                    aria-label="Show Birthday Card"
                >
                    <div className="brand-frame spotify-wrapped-gradient">
                        <div className="brand-frame__surface spotify-wrapped-image">
                            <img
                                src={wrappedIcon}
                                alt="Wrapped"
                                className="wrapped-icon-img"
                                loading="eager"
                                decoding="async"
                                width="270"
                                height="270"
                                fetchPriority="high"
                            />
                        </div>
                    </div>
                    <p className="brand-frame__label spotify-wrapped-username">Our Story</p>
                </button>
            </div>
        </div>
    </div>
);

export default PhotoGrid;
